(function(){

/* SIDEBAR */
var sidebar=document.getElementById('agdSidebar');
var overlay=document.getElementById('agdFilterOverlay');
var closeBtn=document.getElementById('agdSidebarClose');
var mobFilterBtn=document.getElementById('agdMobFilterBtn');

function openSidebar(){sidebar.classList.add('open');overlay.classList.add('open');document.body.style.overflow='hidden';}
window.agdCloseSidebar=function(){sidebar.classList.remove('open');overlay.classList.remove('open');document.body.style.overflow='';};

if(mobFilterBtn)mobFilterBtn.addEventListener('click',openSidebar);
if(closeBtn)closeBtn.addEventListener('click',agdCloseSidebar);
if(overlay)overlay.addEventListener('click',agdCloseSidebar);

/* SORT SHEET */
var sortSheet=document.getElementById('agdSortSheet');
var sortOverlay=document.getElementById('agdSortOverlay');
var mobSortBtn=document.getElementById('agdMobSortBtn');

function openSort(){sortSheet.classList.add('open');sortOverlay.classList.add('open');document.body.style.overflow='hidden';}
function closeSort(){sortSheet.classList.remove('open');sortOverlay.classList.remove('open');document.body.style.overflow='';}

if(mobSortBtn)mobSortBtn.addEventListener('click',openSort);
if(sortOverlay)sortOverlay.addEventListener('click',closeSort);

document.querySelectorAll('.agd-sort-opt').forEach(function(opt){
  opt.addEventListener('click',function(){closeSort();agdSort(this.dataset.val);});
});

/* ACCORDIONS */
document.querySelectorAll('.agd-fhead').forEach(function(btn){
  btn.addEventListener('click',function(){
    var body=this.nextElementSibling;
    var expanded=this.getAttribute('aria-expanded')==='true';
    this.setAttribute('aria-expanded',String(!expanded));
    if(expanded){body.setAttribute('hidden','');}else{body.removeAttribute('hidden');}
  });
});

/* PRICE SLIDER — applies instantly on release, no button */
var pw=document.getElementById('agdPriceFilter');
if(pw){
  var rMin=document.getElementById('agdRangeMin');
  var rMax=document.getElementById('agdRangeMax');
  var fill=document.getElementById('agdRangeFill');
  var minLbl=document.getElementById('agdPriceMinLbl');
  var maxLbl=document.getElementById('agdPriceMaxLbl');
  var absMin=parseInt(pw.dataset.rangeMin);
  var absMax=parseInt(pw.dataset.rangeMax);
  var paramMin=pw.dataset.paramMin;
  var paramMax=pw.dataset.paramMax;

  function fmt(v){return '₹'+parseInt(v).toLocaleString('en-IN');}

  function updateFill(){
    var lo=parseInt(rMin.value),hi=parseInt(rMax.value);
    var pLo=((lo-absMin)/(absMax-absMin))*100;
    var pHi=((hi-absMin)/(absMax-absMin))*100;
    fill.style.left=pLo+'%';
    fill.style.width=(pHi-pLo)+'%';
    minLbl.textContent=fmt(lo);
    maxLbl.textContent=fmt(hi);
  }

  function enforceGap(){
    var lo=parseInt(rMin.value),hi=parseInt(rMax.value);
    if(lo>hi-500){
      if(document.activeElement===rMin){rMin.value=hi-500;}
      else{rMax.value=lo+500;}
    }
  }

  /* Live display update while dragging */
  rMin.addEventListener('input',function(){enforceGap();updateFill();});
  rMax.addEventListener('input',function(){enforceGap();updateFill();});

  /* Navigate on release — Shopify price params need paise (multiply by 100) */
  function applyPrice(){
    var lo=parseInt(rMin.value),hi=parseInt(rMax.value);
    var url=new URL(window.location.href);
    url.searchParams.delete(paramMin);
    url.searchParams.delete(paramMax);
    if(lo>absMin)url.searchParams.set(paramMin,lo);
    if(hi<absMax)url.searchParams.set(paramMax,hi);
    window.location.href=url.toString();
  }

  rMin.addEventListener('change',applyPrice);
  rMax.addEventListener('change',applyPrice);

  updateFill();
}

})();

function agdSort(value){
  var url=new URL(window.location.href);
  url.searchParams.set('sort_by',value);
  window.location.href=url.toString();
}